export class MethodModel {
  Id: number;
  Metodo: string;
  Accion: string;
  Request: string;
  response: string;
  iata: string;
  oid: string;
}
